/**
 * pgc成功
 * 2017-12-6
 */
"use strict";
angular.module("pgcSuccessModule", [
    "pgcSuccessRouter", //路由
]).
controller("pgcSuccessCtrl", ["$scope", "httpService", "$state", "modalDialog", '$validation', '$element', function($scope, httpService, $state, modalDialog, $validation, $element) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus() {
        $scope.status = {};
        $scope.info = {};
        $scope.data = {
            listData: [],
            // isShowTipsA: false, //选择银行
            errBackCard: false, //银行卡号
            // isShowTipsCc: false, //支付宝帐号
        };

        initDropDownList();
    }
    /**
     * [initStatus description] 初始化数据
     */
    function initData() {

    }
    /**
     * [initDropDownList description] 初始下拉
     */
    function initDropDownList() {
        $scope.status.bankOptions = [{
            name: "选择开户银行",
            value: 0
        }, {
            name: "工商银行",
            value: 1,
        }, {
            name: "农业银行",
            value: 2,
        }, {
            name: "中国银行",
            value: 3,
        }, {
            name: "建设银行",
            value: 4,
        }, {
            name: "交通银行",
            value: 5,
        }, {
            name: "上海浦东发展银行",
            value: 6,
        }, {
            name: "兴业银行",
            value: 7,
        }, {
            name: "光大银行",
            value: 8,
        }, {
            name: "深圳发展银行",
            value: 9,
        }, {
            name: "民生银行",
            value: 10,
        }, {
            name: "中信银行",
            value: 11,
        }, {
            name: "招商银行",
            value: 12,
        }, {
            name: "广东发展银行",
            value: 13,
        }, {
            name: "华夏银行",
            value: 14,
        }];
    }
    /**
     * [selectData description] 选择切换改变是否提示正确标志
     * @return {[type]} [description]
     */
    $scope.selectData = function(key) {
        $scope.data.isShowTipsA = key.value == 0 ? false : true;
        key.value == 0 ? $element.find('trs-single-select button span:first-child').removeClass('textColor') : $element.find('trs-single-select button span:first-child').addClass('textColor');

    };
    /**
     * [regularIf description] 判断是否显示正确图标
     * @return {[type]} [description]
     */
    $scope.regularIf = function(key, value) {
        switch (key) {
            case 1: //银行密码
                $scope.isShowTipsB = false;
                $scope.data.isShowTipsBb = false;
                break;
            case 2: //支付宝帐号
                $scope.isShowTipsC = false;
                $scope.data.isShowTipsCc = false;
                // $scope.data.same = false;
                break;
        }
        $validation.validate($scope.pgcSuccess[value]).success(function() {
            switch (key) {
                case 1:
                    $scope.data.isShowTipsBb = true;
                    break;
                case 2:
                    $scope.data.isShowTipsCc = true;
                    break;
            }
        });
    };
    /**
     * [savePwd description]  保存
     * @param  {[type]}   [description]
     */
    $scope.savePwd = function() {
        !$scope.status.selectedBank?delete $scope.info.bankName:$scope.info.bankName = $scope.status.selectedBank.value;
        httpService.http("/mcnww/web/user/pgcUpdate.do", $scope.info, "post").then(function(data) {
            // modalDialog.alertType("提交成功", "", "success", false, function() {});
            $state.go("index.homepage");
        });
    };
    /**
     * [cancel description]  以后再说
     * @param  {[type]}   [description]
     */
    $scope.cancel = function() {
        $state.go("index.homepage");
    }



}]);